"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionGoalToJSON = exports.PromotionGoalFromJSONTyped = exports.PromotionGoalFromJSON = exports.PromotionGoal = void 0;
/**
 * "ARTIST_PROMO": Promote an artist's music on Spotify. With this goal, Streaming
 * Conversion Metrics ("SCM"), which track how the ad set drove results for the artist
 * on Spotify, will be enabled for the ad set. |
 * "PODCAST_PROMO": Promote a podcast show.
 *
 * @export
 */
exports.PromotionGoal = {
    ArtistPromo: 'ARTIST_PROMO',
    PodcastPromo: 'PODCAST_PROMO',
    AlbumPromo: 'ALBUM_PROMO'
};
function PromotionGoalFromJSON(json) {
    return PromotionGoalFromJSONTyped(json, false);
}
exports.PromotionGoalFromJSON = PromotionGoalFromJSON;
function PromotionGoalFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.PromotionGoalFromJSONTyped = PromotionGoalFromJSONTyped;
function PromotionGoalToJSON(value) {
    return value;
}
exports.PromotionGoalToJSON = PromotionGoalToJSON;
